module.exports = __webpack_public_path__ + "img/img3.6966ac12.jpg";